import { Box, Menu, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';
import { NavMenuItem } from 'views/rebranded-module/common/components/Logical/LayoutV2/NavBar/NavMenuItem';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .VMBtn': {
    color: theme.palette.common.white,
    padding: theme.spacing(1, 1.5),
    backgroundColor: theme.palette.secondary.main,
    border: `1px solid ${alpha(theme.palette.common.white, 0.05)}`,
    fontSize: theme.spacing(3),
    '&:hover': {
      border: `1px solid ${theme.palette.common.white}`,
      backgroundColor: theme.palette.secondary.light,
    },
    '&.VMBtnActive': {
      border: `1px solid ${alpha(theme.palette.common.white, 0.05)}`,
      backgroundColor: theme.palette.secondary.light,
    },
  },
  '& .NMAccIcon': {
    marginLeft: theme.spacing(1),
  },
  '& .NMAvatar': {
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginLeft: theme.spacing(1),
    backgroundColor: theme.palette.common.fogWhite,
  },
  '& .NMAvaterLatter': {
    fontSize: theme.spacing(1.4),
    position: 'relative',
    top: theme.spacing(0.25),
  },
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    background: theme.palette.secondary.main,
    border: `1px solid ${alpha(theme.palette.common.white, 0.24)}`,
    borderRadius: theme.spacing(1),
    color: theme.palette.common.white,
    padding: theme.spacing(0),
    backdropFilter: `blur(${theme.spacing(1)})`,
    minWidth: theme.spacing(21.75),
  },
  '& .MuiList-root': {
    padding: theme.spacing(0),
  },
  '& .NMIDivider': {
    backgroundColor: 'unset',
    color: theme.palette.divider[7],
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0.5),
  },
}));
export const StyledNavMenuItem = styled(NavMenuItem)(({ theme }) => ({
  padding: theme.spacing(1.25, 1.75),
  '& .NMILable': {
    fontSize: theme.spacing(2),
  },
  '& .NMIIcon': {
    position: 'relative',
    top: theme.typography.pxToRem(-1),
  },
  '& .NMIUserName': {
    display: 'inline-block',
    maxWidth: theme.spacing(21),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: '700',
    fontSize: theme.spacing(2),
  },
  '&.NMIHasSubLable': {
    '& .NMIIcon': {
      top: 0,
    },
  },
}));

export default StyledBox;
